import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=32e7f310"
import script from "./breadcrumb.vue?vue&type=script&lang=ts"
export * from "./breadcrumb.vue?vue&type=script&lang=ts"
import style0 from "./breadcrumb.vue?vue&type=style&index=0&id=32e7f310&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports